import { alpha } from "@mui/material/styles";

export const COMPLAINT_CLASSIFICATION = {
  UNCLASSIFIED: 0,
  VALID: 1,
  MALICIOUS: 2,
};

export const COMPLAINT_CLASSIFICATION_OPTIONS = [
  COMPLAINT_CLASSIFICATION.UNCLASSIFIED,
  COMPLAINT_CLASSIFICATION.VALID,
  COMPLAINT_CLASSIFICATION.MALICIOUS,
];

export const getClassificationValue = (ticket) => {
  const value = ticket?.complaint_classification?.classification;
  if (value === COMPLAINT_CLASSIFICATION.VALID) {
    return COMPLAINT_CLASSIFICATION.VALID;
  }
  if (value === COMPLAINT_CLASSIFICATION.MALICIOUS) {
    return COMPLAINT_CLASSIFICATION.MALICIOUS;
  }
  return COMPLAINT_CLASSIFICATION.UNCLASSIFIED;
};

export const getClassificationLabelKey = (classification) => {
  switch (classification) {
    case COMPLAINT_CLASSIFICATION.VALID:
      return "complaintClassification.valid";
    case COMPLAINT_CLASSIFICATION.MALICIOUS:
      return "complaintClassification.malicious";
    default:
      return "complaintClassification.unclassified";
  }
};

export const getClassificationBadgeSx = (classification, theme) => {
  const isDark = theme.palette.mode === "dark";

  switch (classification) {
    case COMPLAINT_CLASSIFICATION.VALID:
      return {
        bgcolor: alpha(theme.palette.success.main, isDark ? 0.18 : 0.1),
        color: isDark ? theme.palette.success.light : theme.palette.success.dark,
        border: `1px solid ${alpha(theme.palette.success.main, isDark ? 0.32 : 0.22)}`,
      };
    case COMPLAINT_CLASSIFICATION.MALICIOUS:
      return {
        bgcolor: alpha(theme.palette.error.main, isDark ? 0.18 : 0.1),
        color: isDark ? theme.palette.error.light : theme.palette.error.dark,
        border: `1px solid ${alpha(theme.palette.error.main, isDark ? 0.32 : 0.22)}`,
      };
    default:
      return {
        bgcolor: isDark
          ? alpha(theme.palette.grey[500], 0.16)
          : theme.palette.grey[100],
        color: isDark ? theme.palette.grey[300] : theme.palette.grey[800],
        border: `1px solid ${alpha(theme.palette.grey[500], isDark ? 0.28 : 0.18)}`,
      };
  }
};
